import { laborHoursConstant } from 'src/redux/actions/constant';

const intitialstate: object = {
  response: null,
  isLocationType: false,
  loading: false,
};

export const getLocationTypeLaborHrReducer = (state = intitialstate, action: any) => {
  switch (action.type) {
    case laborHoursConstant.GET_LOCATION_TYPE_SUCCESS: {
      return {
        ...state,
        isLocationType: true,
        response: action.payload?.data,
        loading: false,
      };
    }

    case laborHoursConstant.GET_LOCATION_TYPE_FAILURE:
      return {
        ...state,
        isLocationType: false,
        response: action.payload,
        loading: false,
      };

    case laborHoursConstant.GET_LOCATION_TYPE_LOADER:
      return {
        ...state,
        loading: true,
      };

    default:
      return state;
  }
};
